import { events as ruevents } from "src/i18n/dictionaries/ru/events";

export const events: Record<keyof typeof ruevents, string> = {
  "error.password.required": "Password is required",
  "error.password.min": "Password must be at least 6 characters",
  "error.password.max": "Password must be no longer than 28 characters",
  "error.password.matchUpper":
    "Password must contain at least one uppercase letter",
  "error.password.matchLower":
    "Password must contain at least one lowercase letter",
  "error.password.number": "Password must contain at least one digit",
  "error.password.symbol":
    "Password must contain at least one special character",
  "error.email.format": "Invalid email format",
  "error.email.required": "Email is required",
  "error.description.required": "Description is required",
  "error.nikname.required": "Nickname is required",
  "error.terms.required": "You must accept the terms",
  "error.code.required": "Enter the confirmation code",
  "error.code.min": "The code must be at least 2 characters",
  "error.code.max": "The code must be no longer than 8 characters",
  "error.contact.invalid": "Invalid format",
  "error.name.required": "Title is required",
  "error.date.required": "Date is required",
  "error.results.required": "Outcome is required",
  "error.results.min": "An event must have exactly two outcomes.",
  "error.promoCode.required": "Promo code is required",
  "error.password.match": "Passwords must match",
  "error.date.invalid": "Invalid date",
  "error.date.format": "The format must be XX.XX.XXXX",
};
